import { TopToolbar, usePermissions } from 'react-admin';
import { CustomSelectColumnsButton } from '@/components/global/buttons/CustomSelectColumnsButton.jsx';
import ColumnsIcon from '@/assets/icons/columns-icon.svg?react';
import { SearchFilterInput } from '@/components/global/filters/SearchFilterInput';
import { PeriodFilterInput } from '@/components/global/filters/PeriodFilterInput.jsx';
import CustomFilterButton from '@/components/global/filters/CustomFilterButton';
import CachedDataActionButton from '@/components/global/buttons/CachedDataActionButton.jsx';
import CustomToolbarActionsPopover from '@/components/global/buttons/CustomToolbarActionsPopover.jsx';

const DeviceListActions = () => {
    const { permissions } = usePermissions();

    return (
        <TopToolbar className='toolbar--device'>
            <SearchFilterInput />
            <PeriodFilterInput />
            <CustomFilterButton />
            <CustomSelectColumnsButton startIcon={<ColumnsIcon />} style={{ margin: '0px -4px' }} />
            {permissions.isAdmin && (
                <CustomToolbarActionsPopover>
                    <CachedDataActionButton resource='device' type='Analytics' />
                    <CachedDataActionButton resource='device-service' type='Service' />
                </CustomToolbarActionsPopover>
            )}
        </TopToolbar>
    );
};

export default DeviceListActions;
